// TODO: From App New
<template>
  <div>
    <!-- section -->
    <div class="mb-2 mt-3">
      <hr class="mb-2">
      <b-row>
        <b-col
          md="8"
          xl="6"
        >
          <h3>Varian</h3>
          <p>Tambah varian agar pembeli dapat memilih produk yang sesuai.</p>
        </b-col>
        <b-col
          v-if="!hasVariant"
          md="4"
          xl="3"
          class="text-md-right"
        >
          <b-button
            variant="outline-primary"
            @click="enableVariant"
          ><feather-icon
            icon="PlusIcon"
            class="mr-50"
          />Tambah Varian</b-button>
        </b-col>
        <b-col
          v-else-if="false"
          md="4"
          xl="3"
          class="text-md-right"
        >
          <b-button
            variant="outline-secondary"
            @click="deleteVariantSubVariant"
          ><feather-icon
            icon="TrashIcon"
            class="mr-50"
          />Hapus Varian</b-button>
        </b-col>
      </b-row>
    </div>

    <div v-if="value">
      <table class="table">
        <thead>
          <th>
            No
          </th>
          <th>
            Variant
          </th>
          <th>
            Status
          </th>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in value.options"
            :key="`variant-item-${index}`"
          >
            <td>
              {{ index + 1 }}
            </td>
            <td v-if="item._is_deleted">
              <i>Deleted ID: {{ item.id }}</i>
            </td>
            <td v-else>
              {{ item.name }}
            </td>
            <td>
              <div
                v-if="item._is_added"
                class="badge badge-primary"
              >
                Added
              </div>
              <div
                v-else-if="item._is_updated"
                class="badge badge-warning"
              >
                Updated
              </div>
              <div
                v-else-if="item._is_deleted"
                class="badge badge-danger"
              >
                Deleted
              </div>
              <div
                v-else
                class="badge badge-secondary"
              >
                Remain
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- variant label -->
    <FormLabel
      v-if="hasVariant"
      label="Tipe Varian 1"
    />
    <b-row
      v-if="hasVariant"
      class="mt-50"
    >
      <!-- variant select -->
      <b-col
        md="4"
        xl="3"
      >
        <b-dropdown
          variant="outline-dark"
          block
          toggle-class="pl-1 border-default d-flex justify-content-between"
        >
          <!-- Content -->
          <template #button-content>
            <span
              v-if="variantLabel"
              class="text-capitalize"
            >{{ variantLabel }}</span>
            <span
              v-else
              class="text-muted"
            >Pilih..</span>
          </template>

          <b-dropdown-item
            v-for="(item, index) in options"
            :key="`variant-option-${index}`"
            :disabled="item === subVariantLabel"
            class="text-capitalize"
            @click="changeVariantLabel(item)"
          >{{ item }}</b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item>
            <div class="d-flex align-items-center w-100">
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              Tambah baru
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
      <!-- variant input -->
      <b-col
        v-if="variantLabel"
        md="8"
        xl="6"
      >
        <b-form-row>
          <b-col>
            <b-input-group class="input-group-merge position-relative">
              <b-form-input
                v-model="variantInput"
                :placeholder="`Ketik untuk menambahkan ${variantLabel || 'Variant'}`"
                @keypress.enter.prevent="addVariant"
              />
              <b-input-group-append
                class="cursor-pointer"
                is-text
                @click="addVariant"
              >
                <small class="mr-25">Enter</small><feather-icon icon="CornerDownLeftIcon" />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col cols="auto">
            <button
              v-b-tooltip.v-dark.top="'Hapus Varian'"
              class="btn btn-icon btn-flat-dark"
              @click="deleteVariantSubVariant"
            >
              <feather-icon
                icon="TrashIcon"
                size="16"
              />
            </button>
          </b-col>
        </b-form-row>

        <div
          v-if="variants.length"
          class="d-flex gap-1 flexwrap-wrap mt-50"
        >
          <b-badge
            v-for="(variant, index) in variants"
            :key="`variant-${index}`"
            class="whitespace-nowrap s-14 align-items-center"
            variant="primary"
            :style="{ display: variant._is_deleted ? 'none' : 'flex' }"
          >
            {{ variant.name }}
            <feather-icon
              class="cursor-pointer ml-75"
              icon="Edit2Icon"
              @click="editName(index)"
            />
            <feather-icon
              class="cursor-pointer ml-50"
              icon="XIcon"
              @click="removeVariant(index)"
            />
          </b-badge>
        </div>

        <div class="p-75 border rounded mt-1">
          <div
            v-if="variants.length"
            class="d-flex my-n25 mx-n25 flexwrap-wrap"
          >
            <b-col
              v-for="(variant, index) in variants"
              :key="`variant-image-${index}`"
              cols="auto"
              class="my-25 px-25"
            >
              <b-overlay
                :show="variant.loading"
                rounded="lg"
              >
                <div class="h-100px w-100px position-relative variant-image">
                  <b-img
                    v-if="variant.image_url"
                    :src="$options.filters.thumbnail(variant.image_url, 100)"
                    class="w-100 h-100 img-cover border rounded-lg"
                  />
                  <div
                    v-else
                    class="w-100 h-100 border-dashed rounded-lg d-flex align-items-center justify-content-center"
                  >
                    <div class="text-center mb-1 pb-25">
                      <feather-icon
                        icon="UploadIcon"
                        size="18"
                        class="mb-25"
                      />
                      <div class="s-12">
                        Upload
                      </div>
                    </div>
                  </div>

                  <feather-icon
                    v-if="variant.image_url && !variant.loading"
                    icon="Edit2Icon"
                    size="22"
                    class="variant-image-btn edit__btn"
                    @click="edit(index)"
                  />

                  <b-badge
                    variant="dark"
                    :title="variant.name"
                  >
                    {{ variant.name }}
                  </b-badge>

                  <feather-icon
                    v-if="variant.image_url && !variant.loading"
                    icon="XIcon"
                    size="22"
                    class="variant-image-btn remove__btn"
                    @click="removeVariantImage(index)"
                  />
                </div>
              </b-overlay>
            </b-col>
          </div>
        </div>
      </b-col>
    </b-row>

    <div
      v-if="hasVariant"
      class="py-50"
    >
      <hr class="mb-0 mt-2">
    </div>

    <!-- Refund confirmation modal -->
    <b-modal
      v-model="editNameModal"
      title="Ubah Nama Varian"
      ok-title="Simpan"
      cancel-variant="white"
      cancel-title="Batal"
      @ok.prevent="saveName"
    >
      <b-form-group label="Varian">
        <b-form-input
          v-model="editVariantName"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BFormRow,
  BCol,
  BButton,
  BBadge,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BModal, BFormGroup, BOverlay, BImg,
} from 'bootstrap-vue'
import FormLabel from '@/layouts/components/v2/FormLabelV2.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    BImg,
    BOverlay,
    BFormGroup,
    BRow,
    BFormRow,
    BCol,
    BButton,
    BBadge,
    BFormInput,
    FormLabel,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BModal,
    // ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    subVariant: {
      type: Object,
      default: () => {},
    },
    skus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      variantInput: '',
      subVariantInput: '',
      hasVariant: false,
      editNameModal: false,
      editVariantName: '',
      editVariantIndex: null,
      // hasSubVariant: false,
      // variantLabel: null,
      // subVariantLabel: null,
      // variants: [],
      // subVariants: [],
      // skus: [],
      options: ['ukuran', 'warna', 'laminasi'],
    }
  },
  computed: {
    variants() {
      if (!this.value) {
        return []
      }

      return this.value.options
    },
    variantLabel() {
      if (!this.value) {
        return null
      }

      return this.value.name
    },
    hasSubVariant() {
      return this.subVariant
    },
    subVariants() {
      if (!this.subVariant) {
        return []
      }

      return this.subVariant.options
    },
    subVariantLabel() {
      if (!this.subVariant) {
        return null
      }

      return this.subVariant.name
    },
  },
  watch: {
    value(value, oldValue) {
      // ignore if not first value bind. value bind is only on update mode
      if (oldValue) {
        return
      }

      if (this.variants.length) {
        this.hasVariant = true
      }

      // if variant label from database is not in the default option list
      if (this.variantLabel && this.options.indexOf(this.variantLabel) === -1) {
        // put in the list
        this.options.push(this.variantLabel)
      }
    },
    subVariant(value, oldValue) {
      if (oldValue && !value && this.variants.length) {
        const skus = [...this.skus]

        this.variants.forEach((item, index) => {
          skus.push(this.getSku(item.name, index))
        })

        this.$emit('skus', skus)
      }
    },
  },
  methods: {
    changeVariantLabel(value) {
      this.change({
        ...this.value,
        name: value,
      })
    },
    changeOptions(value) {
      this.change({
        ...this.value,
        options: value,
      })
    },
    change(value) {
      this.$emit('input', value)
    },
    addVariant() {
      if (!this.variantInput) {
        return
      }

      // do not push if already exists
      if (this.variants.findIndex(item => item.name === this.variantInput) !== -1) {
        this.variantInput = ''
        return
      }

      const options = [...this.variants]

      // push to variants with id null, means this variant is not in database yet
      options.push({ id: null, name: this.variantInput, _is_added: true })

      this.addSku(this.variantInput, this.variants.length - 1)
      this.$nextTick(() => this.changeOptions(options))

      this.variantInput = ''
    },
    getSku(variantName, variantIndex) {
      return {
        price: null,
        compare_price: null,
        weight: null,
        stock: null,
        sku_number: null,
        min_purchase: 1,
        max_purchase: null,
        amount_multiple: 1,
        variant: {
          name: variantName,
          index: variantIndex,
        },
        _is_added: true,
      }
    },
    addSku(variantName, variantIndex) {
      const skus = [...this.skus]
      const sku = this.getSku(variantName, variantIndex)

      if (this.hasSubVariant) {
        // loop all the sub-variants to pair with current variant
        this.subVariants.forEach((item, index) => {
          skus.push({
            ...sku,
            sub_variant: {
              name: item.name,
              index,
            },
          })
        })
      } else {
        // if do not have sub variant, then just push it
        skus.push(sku)
      }

      this.$emit('skus', skus)
    },
    editName(index) {
      this.editNameModal = true

      const options = [...this.variants]

      this.editVariantName = options[index].name
      this.editVariantIndex = index
    },
    saveName() {
      const options = [...this.variants]
      const variant = options[this.editVariantIndex]

      const skus = this.skus
        .map(item => {
          if (item.variant && item.variant.name === variant.name) {
            return {
              ...item,
              variant: {
                ...item.variant,
                name: this.editVariantName,
              },
            }
          }

          return item
        })

      if (options[this.editVariantIndex].name !== this.editVariantName) {
        this.input(this.editVariantIndex, 'name', this.editVariantName)
      }

      this.$emit('skus', skus)

      this.editVariantName = ''
      this.editVariantIndex = null
      this.editNameModal = false
    },
    input(index, field, value) {
      const newValue = value || null
      const options = [...this.variants]

      // do not flag as _is_updated for newly created sku
      // because they should be treated as created,
      // and they're still going to the API anyway
      if (options[index]._is_added) {
        options[index][field] = newValue
        this.$nextTick(() => this.changeOptions(options))
        return
      }

      // if there are no changes from previous value(not initial), ignore
      if (options[index][field] === newValue) {
        return
      }

      // if the _initial object is not defined
      if (!options[index]._initial) {
        // then store the current field's initial value while creating the _initial object
        options[index]._initial = { [field]: options[index][field] }
        options[index]._is_updated = true // means _initial object is defined and not empty object
      } else if
      // if the _initial object is defined but the current field's initial value wasn't there
      (options[index]._initial && options[index]._initial[field] === undefined) {
        // then put the current field's initial value there
        options[index]._initial[field] = options[index][field]
      } else if
      // if the new value is the same as the initial value
      (options[index]._initial && options[index]._initial[field] === newValue) {
        // remove the field from the initial array
        // because initial object only consist of modified fields
        delete options[index]._initial[field]
      }

      // if at the end the _initial object is empty,
      // then just remove the _is_updated key and _initial object
      // because it is not needed anymore if there is no changes
      if (Object.keys(options[index]._initial).length === 0) {
        delete options[index]._initial
        delete options[index]._is_updated
      }

      // replace current field's value using the new value
      options[index][field] = newValue
      this.$nextTick(() => this.changeOptions(options))
    },
    removeVariant(index) {
      const options = [...this.variants]
      const variant = options[index]

      const skus = this.skus
        // ignore removing sku when it is just added recently (not stored on database yet)
        .filter(item => !(item._is_added && item.variant && item.variant.name === variant.name))
        .map(item => {
          // put _is_deleted tag if the deleted sku is not recently added (has stored on database)
          // because we want to delete it from database
          if (item.variant && item.variant.name === variant.name) {
            return {
              id: item.id,
              _is_deleted: true,
            }
          }

          return item
        })

      if (variant._is_added) {
        options.splice(index)
      } else {
        options[index] = {
          id: variant.id,
          _is_deleted: true,
        }
      }

      this.$emit('skus', skus)

      this.$nextTick(() => this.changeOptions(options))
    },
    removeVariantImage(index) {
      const options = [...this.variants]
      const variant = options[index]

      variant.image_url = null

      const skus = this.skus
        .map(item => {
          if (item.variant && item.variant.name === variant.name) {
            return {
              ...item,
              variant: {
                ...item.variant,
                image_url: null,
              },
            }
          }

          return item
        })

      if (variant._is_added) {
        options[index] = {
          ...options[index],
          image_url: null,
        }
      } else {
        options[index] = {
          ...options[index],
          image_url: null,
          _is_updated: true,
        }
      }

      this.$emit('skus', skus)

      this.$nextTick(() => this.changeOptions(options))
    },
    deleteVariantSubVariant() {
      if (this.hasSubVariant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Gagal',
            icon: 'AlertTriangleIcon',
            text: 'Harap hapus Tipe Varian 2 terlebih dahulu.',
            variant: 'danger',
          },
        })
        return
      }

      this.hasVariant = false

      const skus = this.skus
        // ignore removing sku when it is just added recently (not stored on database yet)
        .filter(item => !item._is_added)
        .map(item => {
          // put _is_deleted tag if the deleted sku is not recently added (has stored on database)
          // because we want to delete it from database
          if (item.variant) {
            return {
              id: item.id,
              _is_deleted: true,
            }
          }

          return item
        })

      this.change(null)

      this.$emit('skus', [{
        price: null,
        compare_price: null,
        weight: null,
        stock: null,
        sku_number: null,
        min_purchase: 1,
        max_purchase: null,
        amount_multiple: 1,
        _is_added: true,
      }, ...skus])

      // this.hasVariant = false
      // this.hasSubVariant = false
      //
      // this.variantLabel = null
      // this.subVariantLabel = null
      //
      // this.variants = []
      // this.subVariants = []
      //
      // this.variantInput = ''
      // this.subVariantInput = ''
      //
      // this.skus = []
    },
    enableVariant() {
      this.hasVariant = true
      this.change({
        name: null,
        options: [],
      })

      const skus = this.skus
        // ignore removing sku when it is just added recently (not stored on database yet)
        .filter(item => !(item._is_added))
        .map(item => ({
          id: item.id,
          _is_deleted: true,
        }))

      this.$emit('skus', skus)
    },
  },
}
</script>

<style scoped>
.variant-image-btn {
  position: absolute;
  top: -0.5rem;
  cursor: pointer;
  z-index: 1;
  background: grey;
  padding: 4px;
  color: white;
  border-radius: 100%;
  opacity: 0;
  overflow: visible;
}

.variant-image:hover .variant-image-btn {
  opacity: 0.7;
}

.variant-image .badge {
  position: absolute;
  max-width: calc(100% - 1rem);
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.5rem;
  opacity: 0.7;
  text-overflow: ellipsis;
  overflow-x: hidden;
}

.variant-image:hover .badge {
  opacity: 1;
}

.variant-image-btn:hover {
  opacity: 1 !important;
}

.edit__btn {
  right: 1.25rem;
}

.remove__btn {
  right: -0.5rem;
}
</style>
